import { render, staticRenderFns } from "./CriterionCategoryIndex.vue?vue&type=template&id=6cec1756&scoped=true&"
import script from "./CriterionCategoryIndex.vue?vue&type=script&lang=js&"
export * from "./CriterionCategoryIndex.vue?vue&type=script&lang=js&"
import style0 from "./CriterionCategoryIndex.vue?vue&type=style&index=0&id=6cec1756&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cec1756",
  null
  
)

export default component.exports